<template lang='pug'>
.project-report.legacy-report(v-if='loaded')
	h4.report-tab Project Information
	include ../project-report/info-legacy.pug

	h4.report-tab Contacts
	br
	contacts-block(:contacts='project.contacts', :isSecondToo='project.sgnrIsDcsnMkr')

	h4.report-tab Preferred Compliance Actions
	include ../project-report/comp-actions-legacy.pug

	h4.report-tab Additional Information or Details
	include ../project-report/comments-legacy.pug

	h4.report-tab Mechanical systems
	include ../project-report/mech-sys-legacy.pug

	h4.report-tab Floors
	div(v-if="canShow('floors')")
		include ../project-report/floor-legacy.pug
	div(v-if="canShow('floorsAddtn')")
		include ../project-report/floor-addtn-legacy.pug

	h4.report-tab Walls
	div(v-if="canShow('walls')")
		include ../project-report/walls-legacy.pug
	div(v-if="canShow('wallsAddtn')")
		include ../project-report/walls-addtn-legacy.pug

	h4.report-tab(v-if="canShow('glazingExist')") Existing Windows Before Addition
	div(v-if="canShow('glazingExist')")
		include ../project-report/glazing-exist-legacy.pug

	h4.report-tab(v-if="project.takeoff != projType.addtnPrior2018") Windows
	h4.report-tab(v-else="") Addition Windows
	p
		include ../project-report/glazing-legacy.pug

</template>
<script>
import Vue from 'vue'
import _ from 'lodash'
import eControl from 'App/project-report/additional-controls'

export default {
	name: 'print-legacy',
	props: ['projId'],
	data () {
		return {
			project: {},
			control: {},
			extraControl: {},
			loaded: false,
			projType: {},
			addition: {}
		}
	},
	methods: {
		findControlTextByValue (control, value) {
			value = (control === 'y/n' && value === '') ? 'F' : value
			const valObj = _.find(this.control[control], {value: value})
			let out = null

			if (value !== '' && valObj) {
				out = valObj.text
			} else if (value !== '' && !_.isNil(this.control[control])) {
				out = value
			} else {
				out = 'No value selected'
				if (value !== '') {
					console.log('Unable to find control', control, 'with value', value)
				}
			}
			return out
		},
		canShow (screenName) {
			let canShow = false
			switch (this.project.takeoff) {
			case process.env.PROJTYPE.warmZone:
				canShow = (_.indexOf(['floors', 'mechSys', 'walls', 'glazing', 'compliance'], screenName) !== -1)
				break
			case process.env.PROJTYPE.coolZone:
				canShow = (_.indexOf(['floors', 'mechSys', 'walls', 'glazing', 'compliance'], screenName) !== -1)
				break
			case process.env.PROJTYPE.addtnPrior2018:
				canShow = (_.indexOf(['floorsAddtn', 'mechSysAdd', 'wallsAddtn', 'glazing', 'glazingExist', 'compliance'], screenName) !== -1)
				break
			}
			return canShow
		},
		findGlazingByTypeAndWinType (type, winType, value) {
			const glazFind = _.find(this.project.glazing, { type: type, winType: winType })
			if (!_.isNil(glazFind)) {
				return glazFind[value]
			} else {
				return ''
			}
		}
	},
	created () {
		this.projType = process.env.PROJTYPE
		let project
		let extraControl = _.clone(eControl)

		// Convert additional control labels to an object compatible to stored controls in db
		Object.keys(extraControl).forEach((controlKey) => {
			const controlValues = _.clone(extraControl[controlKey])
			extraControl[controlKey] = []
			Object.keys(controlValues).forEach((valueKey) => {
				extraControl[controlKey].push({
					disabled: false,
					sortOrder: null,
					text: controlValues[valueKey],
					value: valueKey
				})
			})
		})
		this.extraControl = extraControl

		console.debug('printing project', this.projId)
		Vue.e24.projectService.findOneById(this.projId).then((projectLoaded) => {
			project = projectLoaded
			return Vue.e24.formService.findControlByForm(['info', 'mech', 'walls', 'glazing_existing', 'glazing', 'floor_attic', 'prefs'])
		}).then((control) => {
			// Loading project
			this.project = project
			this.addition = project.addition
			this.control = control
			this.control = _.merge(this.control, this.extraControl)
			this.loaded = true
		})
	}
}
</script>
<style lang='less'>
// Needed since we are using this components inside admin panel also
@import '~Css/responsive';
@import '~Css/layouts/takeoff';
@import '~Css/layouts/audit';
</style>



// WEBPACK FOOTER //
// src/app/project/print-legacy.vue